var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepotStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9254 24.4058V14.4975C24.9254 14.2601 24.8053 14.0513 24.5994 13.9626L18.2007 11.0451C18.052 10.985 17.8747 10.985 17.7259 11.0451L11.3273 13.9626C11.1185 14.0513 11.0012 14.2601 11.0012 14.4975V24.4058C11.0012 24.7319 11.1125 25.0007 11.4386 25.0007C11.7647 25.0007 11.7244 24.7319 11.7244 24.4058V14.417L18.0234 11.7683L24.2909 14.417V24.4058C24.2909 24.7319 24.1799 25.0007 24.506 25.0007C24.8321 25.0007 25.017 24.7347 24.9254 24.4058Z",
    fill: "#007531"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0708 19.9729H13.2322C12.9061 19.9729 12.6372 20.2418 12.6372 20.5679V24.4065C12.6372 24.7325 12.9061 25.0014 13.2322 25.0014H17.0708C17.3968 25.0014 17.6657 24.7325 17.6657 24.4065V20.5679C17.6657 20.2418 17.3968 19.9729 17.0708 19.9729ZM16.9425 24.3097H13.3604V20.7276H16.9425V24.3097Z",
    fill: "#FFC20E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8711 14.3726H16.0325C15.7064 14.3726 15.4375 14.6414 15.4375 14.9675V18.8061C15.4375 19.1322 15.7064 19.4011 16.0325 19.4011H19.8711C20.1971 19.4011 20.466 19.1322 20.466 18.8061V14.9675C20.466 14.6414 20.1971 14.3726 19.8711 14.3726ZM19.7428 18.7093H16.1607V15.1272H19.7428V18.7093Z",
    fill: "#FFC20E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6711 19.9729H18.8325C18.5064 19.9729 18.2375 20.2418 18.2375 20.5679V24.4065C18.2375 24.7325 18.5064 25.0014 18.8325 25.0014H22.6711C22.9972 25.0014 23.2661 24.7325 23.2661 24.4065V20.5679C23.2661 20.2418 22.9972 19.9729 22.6711 19.9729ZM22.5428 24.3097H18.9608V20.7276H22.5428V24.3097Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepotStock);
export default __webpack_public_path__ + "static/media/depot-stock.5fc4c00d.svg";
export { ForwardRef as ReactComponent };